import {
  localeAwareFormat,
  nextFriday,
  nextMonday,
  nextSaturday,
  nextSunday,
  nextThursday,
  nextTuesday,
  nextWednesday,
} from 'app/lib/date';
import { Row } from '../box';
import { Text } from '../text';

export function CalendarWeekIndicator() {
  const now = new Date();

  const nextWeek = [
    nextSunday(now),
    nextMonday(now),
    nextTuesday(now),
    nextWednesday(now),
    nextThursday(now),
    nextFriday(now),
    nextSaturday(now),
  ];

  return (
    <Row gap="spacing.general.x2" justifyContent="space-between">
      {nextWeek.map((date) => (
        <Text
          color="text.secondary"
          fontWeight="600"
          key={localeAwareFormat(date, 'EEEE')}
          style={{ flex: 1 }}
          textAlign="center"
          variant="bodySmall"
        >
          {localeAwareFormat(date, 'EEEEE')}
        </Text>
      ))}
    </Row>
  );
}
